import { CommitteeManagementPageContent } from ".";

export default function AllCommitteesPage() {
  return <CommitteeManagementPageContent activeTab="all" />;
}
